import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductMenuFooterComponent } from '../product-menu-footer.component';

@Component({
  selector: 'app-spirit-leaf-print-footer',
  templateUrl: './spirit-leaf-print-footer.component.html',
  styleUrl: './spirit-leaf-print-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SpiritLeafPrintFooterComponent extends ProductMenuFooterComponent {}
